import { render, staticRenderFns } from "./create-model.vue?vue&type=template&id=644c815e&scoped=true"
import script from "./create-model.vue?vue&type=script&lang=js"
export * from "./create-model.vue?vue&type=script&lang=js"
import style0 from "./create-model.vue?vue&type=style&index=0&id=644c815e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c815e",
  null
  
)

export default component.exports